import { useMutation, useQueryClient } from "@tanstack/react-query";
import { appointmentKeys } from "../../../appointment/api/appointment.keys";
import { timeEntryApi } from "../service";

export function useDeleteBreak() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      await timeEntryApi.deleteBreak(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: appointmentKeys.lists() });
    },
  });
}
